﻿import React from 'react';
import { CardItemValue } from "../CardItemValue";
import { styled } from "@mui/material/styles";

const Root = styled(CardItemValue)(({ theme }) => ({
  color: theme.palette.warning.main,
}));

type CardItemValueWarningProps = React.ComponentPropsWithoutRef<'span'>;

const CardItemValueWarning = (props: CardItemValueWarningProps) => {
  return <Root {...props} />
}

export { CardItemValueWarning }
